@if (isPanelVisible) {
  <div class="filter-panel">
    @for (filter of filters; track filter) {
      <div (click)="applySelectedFilter(filter)">
        <h3>{{ filter }}</h3>
      </div>
    }
  </div>
}
@if (isPanelVisible) {
  <div class="overlay" (click)="toggleFilterPanel()"></div>
}
